import { Trans } from '@lingui/macro';
import { Breadcrumbs, Breadcrumb, PageHeader } from '@pocketlaw/tetris';
import { useRouteMatch, useParams, Link } from 'react-router-dom';
import { ApiProvider } from 'app/domains/api-management';
import { MainContent, PageLayout } from 'app/domains/common-ui';
import { useCompanyFeatures } from 'app/domains/companies';
import { useRole } from 'app/domains/users/hooks/useRole';
import { PageLoader } from 'shared/domains/common-ui';
import { NotFoundError } from 'shared/domains/errors';
import { useFeatureFlag } from 'shared/domains/featureFlag';
import { SettingsTabs } from './components/SettingsTabs';
import { getComponentRoute, getComponentActions } from './utils';
import { SettingTabsKeys } from './types';
function Settings() {
    const match = useRouteMatch();
    const { activeTab } = useParams();
    const userRole = useRole();
    const { isFeatureAvailable } = useCompanyFeatures();
    const useApiManagement = isFeatureAvailable('web_api');
    const manageApiKeys = useFeatureFlag('feature_api_key_management');
    const apiAccess = useApiManagement && manageApiKeys;
    const TABS = Object.values(SettingTabsKeys).filter(tab => {
        if (!apiAccess && tab === SettingTabsKeys.Api) {
            return false;
        }
        return true;
    });
    if (userRole.state.loading) {
        return <PageLoader delay={0}/>;
    }
    if (!userRole.can('manage:settings') || !TABS.includes(activeTab) || !match.isExact) {
        return <NotFoundError />;
    }
    const ComponentRoute = getComponentRoute(activeTab);
    const ComponentActions = getComponentActions(activeTab);
    return (<ApiProvider>
      <PageLayout>
        <PageHeader actions={ComponentActions} breadcrumbs={<Breadcrumbs>
              <Breadcrumb as={Link} to="/dashboard">
                <Trans comment="Breadcrumb pointing to /dashboard">Pocketlaw</Trans>
              </Breadcrumb>
              <Breadcrumb>
                <Trans comment="Account breadcrumb">Account</Trans>
              </Breadcrumb>
            </Breadcrumbs>} heading={<Trans comment="Account page header">Account</Trans>}/>
        <MainContent>
          <SettingsTabs>
            <ComponentRoute />
          </SettingsTabs>
        </MainContent>
      </PageLayout>
    </ApiProvider>);
}
export default Settings;
